import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const IMAGE_ORDERING_TRACING_ACTIONS = {
  ImageOrderingSubmit: createAction(
    '[NGRXTrace - Order] Track Image Upload Response',
    props<{ tracking: Tracking }>(),
  ),
  ImageOrderingSubmitSuccess: createAction(
    '[NGRXTrace - Order] Track Image Upload Response Success',
    props<{ tracking: Tracking }>(),
  ),
  ImageOrderingSubmitFail: createAction(
    '[NGRXTrace - Order] Track Image Upload Response Fail',
    props<{ tracking: Tracking }>(),
  ),
};
